import { useState, useEffect } from "react";

function useSessionStorage<T>(
  key: string,
  initialValue: T
): [T, (value: T) => void] {
  // Only access sessionStorage on the client
  const getValue = () => {
    if (typeof window === "undefined") {
      return initialValue;
    }

    const stored = window.sessionStorage.getItem(key);

    if (stored !== null) {
      try {
        return JSON.parse(stored) as T;
      } catch {
        // ignore parse error, fallback to initialValue
      }
    }
    return initialValue;
  };

  const [value, setValue] = useState<T>(getValue);

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    }
  }, [key, value]);

  return [value, setValue];
}

export default useSessionStorage;
